import { AbstractRepository } from '../../core/repositories/AbstractRepository';
import ShellLocalStorageDAOImpl from '../../dao/ShellLocalStorageDAOImpl';
import { TenantVisualizationType } from './strategy/types';

export class TenantsDataRepository extends AbstractRepository<
  Record<string, TenantVisualizationType>
> {
  constructor({ shellDAO }: { shellDAO: ShellLocalStorageDAOImpl }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellTenantsData'
    });
  }
}
